import { Activity, BarChart3, Building2, FileText, LogOut, Users } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { cn } from '../lib/utils';
import { Logo } from './Logo';

const navItems = [
  { to: '/', label: 'Dashboard', icon: BarChart3, end: true },
  { to: '/organizations', label: 'Organizaciones', icon: Building2, end: false },
  { to: '/users', label: 'Usuarios', icon: Users, end: false },
  { to: '/monitoring', label: 'Monitoreo', icon: Activity, end: false },
  { to: '/audit-log', label: 'Audit Log', icon: FileText, end: false },
];

export function Sidebar() {
  const { signOut } = useAuth();

  return (
    <aside className="flex h-screen w-56 flex-col bg-sidebar text-sidebar-foreground">
      <div className="flex h-14 items-center gap-2 px-4 border-b border-white/10">
        <Logo size={20} className="shrink-0 text-[#c8963e]" />
        <span className="text-sm font-semibold tracking-wide">Legal Hermes Admin</span>
      </div>

      <nav className="flex-1 space-y-0.5 p-2">
        {navItems.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-sidebar-active/10 text-sidebar-active font-medium'
                  : 'text-sidebar-foreground/70 hover:bg-white/5 hover:text-sidebar-foreground'
              )
            }
          >
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="p-2 border-t border-white/10">
        <button
          type="button"
          onClick={() => void signOut()}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm text-sidebar-foreground/70 hover:bg-white/5 hover:text-sidebar-foreground transition-colors"
        >
          <LogOut size={16} />
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
}
